import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { UserService } from './user.service';

@Injectable()
export class UserGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.userService.user.pipe(map(u => {
      if (!u) {
        this.router.navigate(['login'], {
          queryParams: {
            redirectUrl: state.url
          },
          replaceUrl: true
        });
        return false;
      }
      return true;
    }));
  }
}
